import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode disabled to prevent double API calls in development
// StrictMode causes components to mount/unmount/remount which can trigger duplicate submissions
root.render(
  <App />
);
